import m from "../../es2015/lang/tr_TR";
window.am4lang_tr_TR = m;


//////////////////
// WEBPACK FOOTER
// ./lang/tr_TR.js
// module id = null
// module chunks = 